import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BalkonForm } from '.';
import useGlobal from '../../../store';
import API from '../../../settings/api';
import Button from '../../components/button';
import SillSettingsForm from '../../components/sill.settings';
import WindowsConstructor from '../../components/windows.constructor';
import WindowsSettings from '../../components/windows.settings';
import TextfieldCopyToClipboard from '../../components/textfield.clipboard';
// import WindowsToSuppliers from '../../components/windows.to.suppliers';
import WindowsInnerConstructor from '../../components/windows.inner.constructor';
import WindowsInnerSettings from '../../components/windows.inner.settings';

function copyText(value) {

  if ( navigator.clipboard && navigator.clipboard.writeText ) {

    return navigator.clipboard.writeText( value ).catch(() => fallbackCopy( value ));

  }

  fallbackCopy( value );
  return Promise.resolve();

}

function fallbackCopy(value) {

  const area = document.createElement( 'textarea' );
  area.value = value;
  document.body.appendChild( area );
  area.select();
  document.execCommand( 'copy' );
  document.body.removeChild( area );

}

const BalkonWindows = () => {
  
  const [ globalState, globalActions ] = useGlobal();
  const { project_id } = globalState;
  const { balkon } = globalActions;

  const [ estimateUrl, setEstimateUrl ] = useState( '' );

  const navigate = useNavigate();

  useEffect(() => { document.getElementById('scrollTop').scrollIntoView() }, []);

  return (

    <BalkonForm step = { 3 }>

      {/* Прежнее окно поставщиков оставлено на случай расширения.
      <WindowsToSuppliers

        opened = { isPartnersOpened } 
        close = { () => setIsPartnersOpened( false ) }

      />
      */}
      
      <div id = "scrollTop" className="balkon_settings__title text-center">Окна:</div>
      <WindowsConstructor />
      <WindowsSettings />

      <div className = "balkon_settings__title text-center">Внутренние окна:</div>
      <WindowsInnerConstructor />
      <WindowsInnerSettings />

      <div className="balkon_settings__title text-center">Подоконник:</div>
      <SillSettingsForm disableColorSelector />

      { estimateUrl ? (

        <div>

          <TextfieldCopyToClipboard

            title = "Ссылка на чертёж:"
            value = { estimateUrl }

          />

          <p>Ссылка скопирована</p>

        </div>

      ) : (

        <Button

          text = "Отправить на оценку"
          action = { () => {

            balkon.save(() => {

              const url = `${ API.CONSTRUCTOR_URL }/windows/${ project_id }`;
              setEstimateUrl( url );
              copyText( url );

            }, false );

          }}

        />

      )}

      <hr className="small" />

      <Button

        color = "yellow"
        text = "Пропустить этот шаг"
        action = { () => { balkon.save( () => navigate('/constructor'), false ) }}

      />

      <Button

        text = "Далее"
        action = { () => { balkon.save( () => navigate('/constructor'), false ) }}

      />
    
    </BalkonForm>

  );

}

export default BalkonWindows;